module.exports = __webpack_public_path__ + "img/0x08e7a002104fc8f3130e8ac74f550e8a3022e55f.678eeacb.png";